import React, { useState, useContext, useRef, forwardRef } from 'react';
import $ from 'jquery';
import moment from 'moment';
import Loading from '../components/Loading';
import toastr from 'toastr';
import bootbox from 'bootbox';
import Toastr from 'toastr';
import { Table } from "antd";
import SessionManager from "../routes/SessionManager";
import { Context } from '../../src/views/app';

const supportedFileTypes = ['pdf', 'jpeg', 'jpg', 'png']

function FileDashboard(props, refs) {
    const inputRef = useRef(null);

    let sessionMgr = new SessionManager();
    const appContext = useContext(Context);
    let user = appContext.user;

    const [uploadedFilesList, setUploadedFilesList] = useState([]);
    const [uploading, setUploading] = useState(null);
    const [fetching, setFetching] = useState("Fetching Site Plans ...");
    const [selectedFile, setSelectedFile] = useState(null);
    const [modified, setModified] = useState(false);

    const onFileSelection = (target) => {
        var file = target.files[0];
        setSelectedFile(file);
    }

    const getFileReplaceConfirmation = () => {
        let uploaded_FilesList = uploadedFilesList;
        var isFileNameAvailable = false;
        var fileName = selectedFile.name;

        // Check File extension supporting or not
        var fileNamArray = fileName.split('.')
        var fileExtension = fileNamArray[fileNamArray.length - 1]

        if (supportedFileTypes.indexOf(fileExtension.toLowerCase()) === -1) {
            bootbox.alert("Supported file types are : PDF, JPEG, PNG", function (isYes) {
                document.getElementById("input-file-now").value = "";
            })
            return
        }

        // Check for the same file name from the list
        for (let file_info of uploaded_FilesList) {
            console.log('file_info ', file_info);
            isFileNameAvailable = (file_info.file_name === fileName)
            if (isFileNameAvailable)
                break;
        }

        if (isFileNameAvailable) {
            bootbox.confirm('Are you sure you want to replace the file ?', function (isYes) {
                if (!isYes) {
                    document.getElementById("input-file-now").value = "";
                    return;
                }
                onUploadPress();
            })
        } else {
            onUploadPress();
        }
    }

    const onUploadPress = () => {
        setUploading('Uploading file : ' + selectedFile.name)
        let file = selectedFile;
        var reader = new FileReader();
        reader.onload = (function (theFile) {
            return function (e) {
                var binaryData = e.target.result;
                var base64String = window.btoa(binaryData);
                uploadFileToS3Bucket({
                    file_name: selectedFile.name,
                    file_base64: base64String,
                    user_login: user.user_login,
                    user_token: user.user_token,
                    site_id: user.site_selected.site_id,
                    customer_id: user.customer_id,
                    mime_type: selectedFile.type
                });
            };
        })(file);
        reader.readAsBinaryString(file);
    }

    const uploadFileToS3Bucket = (data) => {
        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/common-s3-operations/sitemap-upload',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (response) => {
                if (response.status.code === 200) {
                    toastr.success("Uploaded Successfully !")
                }
                else {
                    toastr.error("Upload failed.")
                }
                setSelectedFile(null);
                fetchFilesFromS3Bucket();
            }
        )
    }

    const fetchFilesFromS3Bucket = (delayed = true) => {
        if (delayed) {
            setTimeout(fetchFilesFromS3Bucket(false), 2000);
            return;
        }
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            customer_id: user.customer_id,
        };

        $.ajax({
            url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/doc-vault/fetchD',
            type: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
        }).then((response, error) => {
            if (response.status.code === 200) {
                let i = 0;
                for (let u of response.data)
                    u.key = i++;
                // update the localstorage for toggle info
                user.siteplanToggle = response.data;
                for (const toggle of user.siteplanToggle) {
                    toggle.is_modified = true;
                }
                user = sessionMgr.storeCookie("user", user);
                setUploading(null);
                setFetching(null);
                setUploadedFilesList(response.data);
            }
        });
    }

    const formatDate = (date) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    const deleteFileFromS3Bucket = (file_info) => {
        console.log(file_info);
        bootbox.confirm('Are you sure you want to delete the file?', function (isYes) {
            if (!isYes)
                return;
            var fileName = file_info.file_name
            setFetching("Deleting " + fileName + " ...");
            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                site_id: user.site_selected.site_id,
                customer_id: user.customer_id,
                file_name: fileName
            };

            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/doc-vault/delete',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (response) => {
                    if (response.status.code === 200) {
                        toastr.success("Deleted Successfully !");
                    }
                    else {
                        toastr.error("Unable to delete the file.")
                    }
                    setFetching('');
                    fetchFilesFromS3Bucket();

                }
            )
        })

    }

    const onMakeDefaultSelection = (item) => {
        var uploadedFileListTemp = [...uploadedFilesList];
        for (let rec of uploadedFileListTemp) {
            if (rec.file_ref === item.file_ref) {
                rec.is_enabled = !rec.is_enabled;
                rec.is_modified = true;
                break;
            }
        }

        user = sessionMgr.readCookie("user");
        if (JSON.stringify(uploadedFileListTemp) !== JSON.stringify(user.siteplanToggle)) {
            setModified(true);
        } else {
            setModified(false);
        }
        setUploadedFilesList([...uploadedFileListTemp]);

    }

    const handleCancel = () => {
        inputRef.current.value = "";
        fetchFilesFromS3Bucket();
        setSelectedFile(false);
        setModified(false);
    }

    const saveDefaultSelectedPDF = () => {
        var saveBtn = document.getElementById("SaveBtn");
        saveBtn.innerHTML = 'Saving ...';
        saveBtn.disabled = true;

        let uploadedFilesListTemp = [...uploadedFilesList];
        let promises = [];
        for (let item of uploadedFilesListTemp) {
            if (item.is_modified) {
                delete item.is_modified;
                promises.push(modifySitePlanPromise(item));
            }
        }
        if (promises.length > 0) {
            Promise.all(promises).then(data => {
                console.log(data);
                saveBtn.innerHTML = 'Save';
                saveBtn.disabled = false;
                if (data.indexOf(false) === -1) {
                    Toastr.success('SitePlans modified successfully !');
                } else {
                    Toastr.error('An error occured ...please try again!');
                }
                setModified(false);
                fetchFilesFromS3Bucket();
            }).catch(function (err) {
                console.log(err);
                Toastr.error('An error occured ...please try again!');
                saveBtn.innerHTML = 'Save';
                saveBtn.disabled = false;
            });
        }
    }

    const modifySitePlanPromise = (siteplan) => {
        return new Promise((resolve, reject) => {
            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                site_id: siteplan.site_id,
                customer_id: siteplan.customer_id,
                file_name: siteplan.file_name,
                is_enabled: siteplan.is_enabled
            };

            $.ajax({
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/doc-vault/modify-siteplan',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }).then((res) => {
                resolve(res.status.code === 200);
            }, (error) => {
                resolve(false);
            });
        });
    }

    React.useImperativeHandle(refs, () => ({
        fetchFilesFromS3Bucket,
        saveDefaultSelectedPDF,
        modified
    }));

    let columns = [
        {
            title: "File Name",
            dataIndex: "file_name",
            key: "file_name",
        },
        {
            title: "Timestamp",
            dataIndex: "created_ts",
            key: "created_ts",
            width: 150,
            render: (created_ts) => formatDate(created_ts)
        },
        {
            title: <i className="fa fa-cog"></i>,
            key: "file_name",
            width: 120,
            className: 'text-center nowrap',
            render: (item) =>
                <span className="text-nowrap pull-right">
                    <span className="btn btn-sm btn-custom mr-2" onClick={() => onMakeDefaultSelection(item)} data-toggle="tooltip" data-placement="left" title="Show in SiteMaps"><i className={item.is_enabled + '' === "true" ? "fa fa-lg fa-toggle-on text-success cursor-pointer" : "fa fa-lg fa-toggle-off text-success cursor-pointer"}></i></span>
                    <a rel="noopener noreferrer" className="btn btn-sm btn-primary mr-2" target="_blank" href={item.signed_url}><i className="fa fa-download" data-toggle="tooltip" data-placement="left" title="Download"></i></a>
                    <button className="btn btn-sm btn-danger" onClick={() => deleteFileFromS3Bucket(item)}><i className="fa fa-trash-alt" data-toggle="tooltip" data-placement="left" title="Remove"></i></button>
                </span>
        }];

    return (
        <React.Fragment>
            <div className="bg-white">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-12">
                                {uploading && <div className="row"><div className="col-md-12 p-2"><span className="ml-3"><Loading>{uploading}</Loading></span></div></div>}
                                {!uploading && !fetching &&
                                    <div className="text-right">
                                        <input style={{ width: "250px" }} className="file-upload p-1 m-2 bg-light border-rounded" type="file" id="input-file-now" onChange={(event) => onFileSelection(event.target)} accept=".pdf,.png,.jpg" ref={inputRef} />
                                        <button disabled={selectedFile ? false : true} className="btn btn-sm btn-primary btn-border-1 mr-2" onClick={getFileReplaceConfirmation.bind()}>Upload</button>
                                        <button className='btn btn-sm btn-light btn-border-1' onClick={handleCancel}>Cancel</button>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="row">
                            {fetching && <span className="m-3"><Loading>{fetching}</Loading></span>}
                            {!fetching &&
                                <div className="col-md-12">
                                    {
                                        uploadedFilesList &&
                                        <Table dataSource={uploadedFilesList} columns={columns} scroll={{ x: 'calc(700px + 20%)', y: 'auto' }}></Table>
                                    }
                                    <div className="float-right mr-2">
                                        <button id="SaveBtn" disabled={!modified} className="btn btn-sm btn-primary btn-border-1" onClick={(event) => saveDefaultSelectedPDF()}>Save</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}
export default forwardRef(FileDashboard);